const VERIFY_OTP_PAGE_Styles = {
  resendOtp: `text-center text-primaryHeading absolute -bottom-[35px] left-1/2 -translate-x-1/2 cursor-pointer disabled:cursor-default
              hover:underline disabled:hover:!no-underline
  `,
};  

export { VERIFY_OTP_PAGE_Styles };
  